import React, { Component } from 'react';
import PropTypes from 'prop-types';
import i18n from '../../../../../i18n';
import '../../../../../styles/components/overview-button.scss';
import { getAuctionOverview } from '../service/auctionDetailsService';

const Sparkle = (props) => (
    <svg viewBox="0 0 24 24" fill="currentColor" aria-hidden="true" className="ao-sparkle" {...props}>
        <path className="ao-sparkle__big" d="M12 2.5l1.9 5.1 5.1 1.9-5.1 1.9L12 16.5l-1.9-5.1L5 9.5l5.1-1.9L12 2.5z" />
        <path className="ao-sparkle__small" d="M18.6 15.4l.85 2.25 2.25.85-2.25.85-.85 2.25-.85-2.25-2.25-.85 2.25-.85.85-2.25z" />
    </svg>
);

const WarnIcon = () => (
    <svg viewBox="0 0 24 24" width="16" height="16" fill="currentColor" aria-hidden="true">
        <path d="M12 2l10 19H2L12 2zm0 6v6h1.6V8H12zm-.2 8.2v1.8h2v-1.8h-2z" />
    </svg>
);

export default class AuctionOverviewCard extends Component {
    constructor(props) {
        super(props);
        this.state = { open: false, status: 'idle', data: null }; // idle | loading | ready | error
        this.loadedFor = null;
        this.mounted = false;
        this.handleToggle = this.handleToggle.bind(this);
        this.load = this.load.bind(this);
    }

    componentDidMount() {
        this.mounted = true;
    }

    componentDidUpdate(prevProps) {
        if (prevProps.auctionId !== this.props.auctionId) {
            this.loadedFor = null;
            this.setState({ open: false, status: 'idle', data: null });
        }
    }

    componentWillUnmount() {
        this.mounted = false;
    }

    load() {
        const { auctionId } = this.props;
        this.setState({ status: 'loading' });

        getAuctionOverview(auctionId, i18n.language === 'ar' ? 'ar' : 'en')
            .then((res) => {
                if (!this.mounted) return;
                const data = res && res.data ? res.data : res;
                this.loadedFor = auctionId;
                this.setState({ data, status: 'ready' });
            })
            .catch(() => {
                if (this.mounted) this.setState({ status: 'error' });
            });
    }

    handleToggle() {
        const { auctionId } = this.props;
        const { open, data } = this.state;

        if (open) {
            this.setState({ open: false });
            return;
        }

        this.setState({ open: true });
        if (this.loadedFor === auctionId && data) this.setState({ status: 'ready' });
        else this.load();
    }

    renderPanel() {
        const { data } = this.state;
        if (!data) return null;

        return (
            <div className="ao-card__panel">
                <header className="ao-card__panelHead">
                    <div>
                        <p className="ao-card__eyebrow">{i18n.t('ao_eyebrow')}</p>
                        {data.verdict ? <p className="ao-card__verdict">{data.verdict}</p> : null}
                    </div>
                    {/* {data.chip ? <span className="ao-card__chip">{data.chip}</span> : null} */}
                </header>

                <div className="ao-card__panelBody">
                    {data.summary ? (
                        <div className="ao-card__summary">
                            <span className="ao-card__summaryBar" aria-hidden="true" />
                            <p>{data.summary}</p>
                        </div>
                    ) : null}


                    {data.warning ? (
                        <p className="ao-card__warning">
                            <WarnIcon />
                            <span>{data.warning}</span>
                        </p>
                    ) : null}

                    <p className="ao-card__disclaimer">
                        {data.disclaimer || i18n.t('ao_disclaimer')}
                    </p>
                </div>
            </div>
        );
    }

    render() {
        const { auctionId } = this.props;
        const { open, status } = this.state;
        const panelId = `auction-overview-${auctionId}`;
        const isRtl = i18n.language === 'ar';

        return (
            <section className={'ao-card' + (isRtl ? ' ao-card--rtl' : '')} dir={isRtl ? 'rtl' : 'ltr'}>
                <button
                    type="button"
                    className="ao-card__trigger"
                    onClick={this.handleToggle}
                    aria-expanded={open}
                    aria-controls={panelId}
                >
                    <span className="ao-card__triggerIcon">
                        <Sparkle width="17" height="17" />
                    </span>
                    <span className="ao-card__triggerLabel">{i18n.t('ao_trigger_label')}</span>
                    <span className="ao-card__triggerChip">{i18n.t('ao_ai_chip')}</span>
                </button>

                {open ? (
                    <div id={panelId} role="region" aria-label={i18n.t('ao_trigger_label')} className="ao-card__body">
                        {status === 'loading' ? (
                            <div className="ao-card__status" aria-live="polite">
                                <span className="ao-card__spinner" />
                                {i18n.t('ao_loading')}
                            </div>
                        ) : null}

                        {status === 'error' ? (
                            <div className="ao-card__status" aria-live="polite">
                                <span>{i18n.t('ao_error')}</span>
                                <button type="button" className="ao-card__retry" onClick={this.load}>
                                    {i18n.t('ao_retry')}
                                </button>
                            </div>
                        ) : null}

                        {status === 'ready' ? this.renderPanel() : null}
                    </div>
                ) : null}
            </section>
        );
    }
}

AuctionOverviewCard.propTypes = {
    auctionId: PropTypes.oneOfType([PropTypes.string, PropTypes.number]).isRequired,
};